import React from 'react';
import { fieldToTextField } from 'formik-material-ui';
import CustomTextField from '../Form/TextField';

const TextField = ({ children, ...props }) => {
  return <CustomTextField {...fieldToTextField(props)}>{children}</CustomTextField>;
};

export default TextField;
